export default "__VITE_ASSET__fcec08e4__"